

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const GETQUESTIONBYIID= createAsyncThunk(
  "getQuestionById/getQuestionById",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getQuestionByIdSlice = createSlice({
  name: "getQuestionByIdSlice",
  initialState: {
    getQuestionById: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetQuestionById: (state) => {
        state.getQuestionById.loading = false
        state.getQuestionById.error = false
        state.getQuestionById.data = []
        state.getQuestionById.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETQUESTIONBYIID.fulfilled, (state, action) => {
      state.getQuestionById = {
        ...state.getQuestionById,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETQUESTIONBYIID.pending, (state, action) => {
      state.getQuestionById = {
        ...state.getQuestionById,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETQUESTIONBYIID.rejected, (state, action) => {
      state.getQuestionById = {
        ...state.getQuestionById,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getQuestionByIdAction = {
    GETQUESTIONBYIID,
};

export { getQuestionByIdAction };
export default getQuestionByIdSlice.reducer;
export const {setInitialStateOfgetQuestionById} = getQuestionByIdSlice.actions
